import { render } from "./BlogChatGptIntegration.vue?vue&type=template&id=1a031b8c"
import script from "./BlogChatGptIntegration.vue?vue&type=script&lang=js"
export * from "./BlogChatGptIntegration.vue?vue&type=script&lang=js"

import "./BlogChatGptIntegration.vue?vue&type=style&index=0&id=1a031b8c&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__